// extracted by mini-css-extract-plugin
module.exports = {"postTags":"post-tags-module--post-tags--bG__h","tag":"post-tags-module--tag--oKsv4"};